<template>
  <div class="content">
    <van-notice-bar color="#fff" background="#333" style="font-size: 3.2vw" :scrollable="false" left-icon="info-o">
      微信提示：您提交的重要信息，我公司将严格保护。
    </van-notice-bar>
    <div class="list-box">
      <div class="title">用户注册</div>
      <div class="item-box">
        <div class="name">手机号码</div>
        <input v-model="mobile" placeholder="请输入手机号码" type="number" />
      </div>
      <div class="item-box">
        <div class="name">短信验证码</div>
        <div class="justify-align code-box">
          <input v-model="smsCode" placeholder="请输入验证码" type="number" />
          <div class="code-btn" @click.prevent="getCode()">
            <span v-show="show">获取验证码</span>
            <span v-show="!show" class="count">{{count}} s</span>
          </div>
        </div>

      </div>
      <div class="item-box">
        <div class="name">密码</div>
        <input v-model="password" placeholder="请输入登录密码" type="text" />
      </div>
      <div class="item-box">
        <div class="name">密码</div>
        <input v-model="affirmPassword" placeholder="请输入登录密码" type="text" />
      </div>
    </div>
    <div class="remember-info left-justifying">
      <van-checkbox v-model="checked" checked-color="#ea5e2d">我同意</van-checkbox>
      <div style="color: #ea5e2d" @click="clickShowProtocol">《用户注册协议》</div>
    </div>
    <van-button @click="onSubmit" color="#ea5e2d" style="width: 80%;margin-top: 4vw;margin-bottom: 2.66667vw;" type="primary" round>注册</van-button>

    <div class="link-box justify-align ">
      <div class="" style="color: #333333;">已有账号？</div>
      <router-link to='/consumerLogin'><div class="register">立即登录</div></router-link>
    </div>
<!--    弹框协议-->
    <van-popup v-model="showProtocol" :close-on-click-overlay="false" :round="true">
      <div class="protocol-content">
        <div class="title-protocol">《用户服务协议》</div>

        <div class="protocol-content-box">
          <h6>平安银行快捷支付业务服务协议</h6>
         <p> 本协议是由平安银行股份有限公司（以下简称“我行”）与持卡人(以下简称 “您”)就财付通借记卡/信用卡快捷支付服务（以下简称“本服务”）的使用等相关事项所订立的有效合约。
           您通过互联网（Internet）点击确认或以其他方式选择接受本协议，
           即表示您同意接受本协议的全部约定内容，确认承担由此产生的一切责任。</p>

          <p>在接受本协议之前，请您仔细阅读本协议的全部内容（特别是以粗体下划线标注的内容）。如果您不同意本协议的任何内容，或者无法准确理解相关条款，请不要进行后续操作。</p>

          <p>您应确保您在使用本服务时绑定的借记卡/信用卡为您本人所有，并确保您将您的财付通账户与该借记卡/信用卡绑定且用其支付的行为合法、有效，未侵犯任何第三方合法权益；
          否则，因此造成我行、第三方损失的，您应负责赔偿并承担全部法律责任。</p>

          <p style="color: #000;font-weight: bold">您同意我行对财付通支付科技有限公司（以下简称“财付通”）收集并转交我行的，您在使用本服务过程中所填写的包括但不限于姓名、
          借记卡/信用卡卡号、手机号码、身份证号码等信息进行校对核验；并同意将该借记卡/信用卡与您的财付通账户进行绑定，以便您此次及今后进行支付。
          同时我行与财付通可根据业务具体情况变更上述确认要素作为校验标准。</p>

          <p style="color: #000;font-weight: bold">一旦绑定成功，您在财付通网站或相关使用界面输入财付通账户密码或财付通账户密码及您所收到的手机校验码后，即视为您确认支付金额及该支付指令，
          并由财付通转交我行进行后续处理。您同意并授权我行按照财付通的交易指令从您绑定的借记卡/信用卡账户中扣除相应款项。</p>

          <div class="p-div">您应妥善保管该卡开户户名、开户类型、与之相关的证件类型及证件号码、手机号码、固定电话、通信地址等与该卡有关的一切信息
          （以下简称“身份信息及卡信息”）。如您遗失借记卡/信用卡、泄露身份信息及或卡信息，您应及时通知我行，以减少可能发生的损失。
          <b>因您泄露密码、数字证书、U盾、丢失借记卡/信用卡等所致损失需由您自行承担。</b></div>

          <p>我行可根据业务发展需要，设置或修改支付限额，您对此无异议。您在使用本服务时需同时受我行和财付通设置的支付限额的约束。
          在任何情况下，支付金额不应超过我行或财付通设置的支付限额（以较少者为准，以下简称“支付限额”）。如实际支付金额大于支付限额，我行将拒绝执行交易指令。</p>

          <p>本协议与我行借记卡/信用卡章程或协议相冲突部分，以本协议为准。</p>

          <p>您不得利用财付通快捷支付服务进行套现、虚假交易、洗钱等行为，且有义务配合我行进行相关调查，
          一旦您拒绝配合进行相关调查或我行认为您存在或涉嫌虚假交易、洗钱、套现或任何其他非法活动、欺诈或违反诚信原则的行为、
          或违反本协议约定的，我行有权采取以下一种、多种或全部措施：（1）暂停或终止提供本协议项下财付通快捷支付服务；（2）终止本协议；（3）取消您的用卡资格。</p>

          <p>您同意，我行有权在通过我行网站或其他合理的渠道进行公告后变更、暂停本协议项下财付通快捷支付服务，或对本协议进行修改、终止。
          相关公告经网站或其他合理的渠道发布后3个自然日即视为您已收到并于您收到之日开始执行。若您不同意关于本协议、快捷支付服务的修改、变更，
          可及时致电95511就有关事项进行咨询或取消该项服务。您在前述公告执行后继续办理财付通快捷支付业务的，视同您接受有关本协议、快捷支付服务的修改、
          变更。本协议终止后，财付通在协议终止前已接收并发送我行进行处理的交易指令仍有效，您应承担其后果。</p>

          <p>如您对本协议存在任何疑问或任何相关投诉、意见，请通过客服电话95511转3、95511转2（信用卡）、
          官方网站（http://bank.pingan.com）、平安银行APP“在线客服”或“意见反馈”、发送邮件至callcenter@pingan.com.cn、
          或前往我行各营业网点进行咨询或反映。受理您的问题后，乙方将在规定时效内核实有关事项并及时联系您提供解决方案。

          本协议的成立、生效、履行和解释,均适用中华人民共和国法律(除香港、澳门、台湾地区法律);法律无明文规定的,可适用通行的金融惯例。</p>

          <p>我行仅为您提供支付结算服务，依据财付通提供的交易指令实施资金扣划。对于因购买商品或服务而产生的一切关于商品、
          服务及费用扣收的争议均由您与财付通或特约商户自行协商解决,与我行无关。</p>

          <p>本协议履行过程中,如发生争议,双方应尽量协商解决。协商不成的,任何一方均应向您所绑定银行卡的开户行所在地有管辖权的人民法院提起诉讼。</p>
        </div>
        <div class="disabled" v-if="canClick==false">{{contentTxt}}</div>
        <div class="accept-btn" v-else @click="closeBox">{{contentTxt}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import axios from 'axios'

export default {
  name: 'register',
  data() {
    return {
      checked: false,
      mobile: '',
      password: '',
      affirmPassword: '',
      smsCode: '',
      show: true,
      count: 60,
      showProtocol: false,
      contentTxt: '我接受',  // 按钮里显示的内容
      totalTime: 10,      //记录具体倒计时时间
      canClick: false
    };
  },
  methods: {
    clickShowProtocol(){
      this.showProtocol = true
      this.countDown()
    },
    closeBox(){
      this.showProtocol = false
      this.canClick = false
      this.totalTime = 10
    },
    countDown () {
      this.contentTxt = '我接受'+this.totalTime + 's' //这里解决60秒不见了的问题
      let clock = window.setInterval(() => {
        this.totalTime--
        this.contentTxt = '我接受'+ this.totalTime + 's'
        if (this.totalTime < 0) { //当倒计时小于0时清除定时器
          window.clearInterval(clock)

          this.contentTxt = '我接受0s'
          this.totalTime = 10
          this.canClick = true

        }

      },1000)

    },
    onSubmit(){
      if(this.mobile == ''){
        Toast('手机号码');
        return false
      }else if (this.smsCode == ''){
        Toast('验证码');
        return false
      } else if (this.password == ''){
        Toast('密码');
        return false
      }else if (this.checked == false){
        Toast('请勾选协议');
        return false
      }
      var data = {
        mobile: this.mobile,
        smsCode: this.smsCode,
        password: this.password
      }
      axios.post('https://mapi.bte.group/member/passport/signup',data)
        .then(response => {
          var res = response.data
          if (res.message = 'ok'){
            this.$router.push('/consumerLogin');
          }
        })
        .catch(error => {
          Toast(error.response.data.message);
        })
        .finally(() => this.loading = false)

    },
    // 获取短信验证码
    getCode() {
      if(this.mobile == ''){
        Toast('手机号码');
        return false
      }
      //axios请求
      var data = {
        mobile: this.mobile,
        scene: 'signup'
      }
      // console.log(this.form.phone);
      axios.post('https://mapi.bte.group/common/sms/send',data)
        .then(response => {
          // this.info = response
          console.log(response)
          var res = response.data
          if (res.message = 'ok'){
            Toast('已发送');
          }
        })
        .catch(error => {
          Toast(error.response.data.message);
          this.show = true
          this.errored = true
        })
      // 验证码倒计时
      if (!this.timer) {
        this.count = 60;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  text-align: center;
}
.protocol-content{
  .accept-btn{
   padding: 20px 20px;width:40%;margin: 10px auto 20px;background: #ea5e2d;color: #ffffff;font-size: 24px;
  }
  .disabled{
    background: #f5a98c;color: #ffffff;font-size: 24px;padding: 20px 20px;width:40%;margin: 10px auto 20px;
  }
  .title-protocol{
    padding: 20px 0;font-size: 32px;
  }
  h6{
    margin: 20px 0 5px;font-size: 30px;text-align: center;
  }
  .protocol-content-box{
    height: 800px;overflow-y: auto;font-size: 24px;width: 600px;text-align: left;
    p{
      padding: 0 10px;text-align: left;line-height: 40px;
    }
    .p-div{
      padding: 0 10px;text-align: left;line-height: 40px;
    }
  }
}
.logo{
  width: 80%;height: auto;display: block;margin: 0 auto;
}
.list-box{
  font-size: 28px;
  .title{
    font-size: 42px;color: #666;text-align: left;padding: 24px;
  }
  .code-box{
    position: relative;
    .code-btn{
      width: 200px;
      background: #ea5e2d;border-radius: 100px;color: #fff;font-size: 24px;text-align: center;padding: 10px 0;
      position: absolute;right: 0px;top: 0;
    }
  }

  .item-box{
    text-align: left;padding: 10px 24px;
    .name{
      padding-bottom: 10px;
    }
    input{
      border: none;
      border-bottom: 1px solid #f5f5f5; width: 100%;height: 60px;line-height: 60px;
    }
  }
}
.remember-info{
  font-size: 26px;margin: 20px 24px 40px;
}
.link-box{
  font-size: 28px;width: 40%;margin: 20px auto;
  .register{
    text-decoration:underline;color: #ea5e2d;
  }
}
</style>

